import React, { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { unsplashSrc, unsplashSrcSet } from "@/lib/img";

// Deliberate framed image with subtle parallax on the inner image.
// Below-the-fold by design: lazy-loaded, responsive srcset, CDN auto-format.
export function ParallaxImage({ src, alt, className = "", intensity = 60, rounded = false, sizes = "(min-width: 1024px) 50vw, 100vw" }) {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [-intensity, intensity]);

  return (
    <div
      ref={ref}
      className={`relative overflow-hidden ${rounded ? "rounded-sm" : ""} ${className}`}
    >
      <motion.img
        src={unsplashSrc(src, 1280)}
        srcSet={unsplashSrcSet(src, [480, 768, 1024, 1280, 1600])}
        sizes={sizes}
        alt={alt}
        loading="lazy"
        decoding="async"
        style={{ y }}
        className="absolute inset-0 h-[calc(100%+120px)] w-full -top-[60px] object-cover"
      />
    </div>
  );
}
